import React from 'react';

const Row = ({ label, value }) => {
  return (
    <div className="flex items-center justify-between px-3 py-2">
      <span className="text-xs text-muted-foreground caption">{label}</span>
      <span className="text-sm font-bold text-foreground data-text">{value}</span>
    </div>
  );
};

const MobileStatisticsList = ({ statistics }) => {
  return (
    <div className="sm:hidden bg-card rounded-lg shadow-gaming-md border border-border overflow-hidden">
      <div className="divide-y divide-border">
        <Row label="전체 목표" value={Number(statistics?.totalProjects || 0).toLocaleString('ko-KR')} />
        <Row label="완료한 챌린지" value={Number(statistics?.completedChallenges || 0).toLocaleString('ko-KR')} />
        <Row label="제출한 증명" value={Number(statistics?.submittedProofs || 0).toLocaleString('ko-KR')} />
        <Row label="평균 별점" value={Number(statistics?.averageStars || 0).toLocaleString('ko-KR')} />
        <Row label="받은 좋아요" value={Number(statistics?.receivedLikes || 0).toLocaleString('ko-KR')} />
      </div>
    </div>
  );
};

export default MobileStatisticsList;
